/* eslint-disable react/jsx-no-target-blank */

import {AsideMenuItemWithSub} from '../../AsideMenuItemWithSub'
import {AsideMenuItem} from '../../AsideMenuItem'

const galeriaAdmin = () => {
  

  return (
      <AsideMenuItemWithSub
        to='/fotos-y-videos'
        title= {"Fotos y Videos"}
        featherIcon={<i className="fa-solid fa-photo-film fs-3 "></i>} 
      >
        
        <AsideMenuItem
          to='/fotos-y-videos/admin'
          title={"Administrar Fotos y Videos"}
          biIcon="bi bi-grid-1x2"
        />
        {/* <AsideMenuItem
          to='/informacion-publica/solicitudes'
          title={"Solicitudes de Información Pública"}
          biIcon="bi bi-grid-1x2"
        /> */}
      </AsideMenuItemWithSub>
  )
}

export default galeriaAdmin